import React from 'react';
import './CalendarDayIcon.css';

export default function CalendarDayIcon({
  date = new Date(),
  size = 28,
  className = '',
  forceToday = false,
  monthBg,
  monthColor,
  dayBg,
  dayColor
}) {
  const base = forceToday ? new Date() : new Date(date);
  const day = base.getDate();
  const month = base.toLocaleString('en-US', { month: 'short' }).toUpperCase();

  // Inline style layer (wins over rogue CSS)
  const wrapperStyle = { width: size, height: size };
  // Always set month/day colours via inline styles so no CSS rule can
  // override them (we removed all !important from the stylesheets).
  // Use hardcoded colours — CSS variable fallbacks in inline styles
  // proved unreliable across themes.
  const monthStyle = {
    background: monthBg || '#0560fd',
    color: monthColor || '#ffffff',
    WebkitTextFillColor: monthColor || '#ffffff',
  };
  const dayStyle = {
    background: dayBg || '#ffffff',
    color: dayColor || '#1e293b',
    WebkitTextFillColor: dayColor || '#1e293b',
  };

  return (
    <div
      className={`cal-day-icon ${className}`}
      style={wrapperStyle}
      aria-label={`${month} ${day}`}
    >
      <div className="cal-day-icon-month" style={monthStyle}>{month}</div>
      <div className="cal-day-icon-day" style={dayStyle}>{day}</div>
    </div>
  );
}